import React from "react";

import { Plus } from "icons";
import { string, func } from "prop-types";

import { Button, Typography } from "clearsense-ui/components";

import PermissibleWrapper from "./PermissibleWrapper";

// import DefaultIllustration from "../../../../assets/images/noData.svg";
import { ReactComponent as DefaultIllustration } from "../../assets/images/noData.svg"

const NoData = ({
  actionLabel = "Create Entity",
  entity = "entities",
  acceptablePermissions = [],
  currentPermissions = "all",
  onAction,
}) => (
  <div
    className="flex items-center justify-center w-full h-full"
    data-testid="no-data-container"
  >
    <div className="flex flex-col items-center justify-center h-[75%] w-[75%] lg:h-[60%] lg:w-[60%] relative">
      <div className="flex items-center justify-center w-full">
        <DefaultIllustration width="100%" />
      </div>
      <div className="lg:absolute lg:top-0 xl:top-[7%] lg:left-[33%] lg:right-[20%] mt-5 text-center">
        <Typography
          style="h3"
          type="semibold"
          className="text-xl lg:text-[1.5vw]"
        >
          <div style={{ lineHeight: 1.3 }}>No data here to show!</div>
        </Typography>
        <Typography
          type="semibold"
          className="mt-3 text-center text-sm lg:text-[0.95vw] lg:mt-2"
        >
          <div style={{ lineHeight: 1.5 }}>
            There are no {entity} to show you here. Let's create it!
          </div>
        </Typography>
      </div>
      {onAction && (
        <PermissibleWrapper
          currentPermissions={currentPermissions}
          acceptablePermissions={acceptablePermissions}
        >
          <Button
            icon={Plus}
            label={actionLabel}
            className="mt-5 lg:mt-8"
            onClick={onAction}
            data-testid="action-button"
          />
        </PermissibleWrapper>
      )}
    </div>
  </div>
);

NoData.propTypes = {
  actionLabel: string,
  entity: string,
  onAction: func,
};

export default NoData;
